import { Suspense, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Promotional from "../Promotional/promotional";
import PrivacyPolicy from "../Promotional/privacyPlolicy";
import TermsConditions from "../Promotional/termsConditions";
import AboutUs from "../Promotional/aboutUs";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

const AppRoutes = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Promotional />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/about-us" element={<AboutUs />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
